// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__sGo30","fullScreen":"style_fullScreen__2hMJt","hidden":"style_hidden__uuBWJ"};